import React, { useEffect, useState } from "react";
import { Popup } from "antd-mobile";
import MobileDetect from "mobile-detect";

export default function SafeAreaMask() {
  const [showVersion, setShowVersion] = useState(false);
  const mobileDetect = new MobileDetect(navigator.userAgent);

  useEffect(() => {
    let version;
    if (mobileDetect.is("iPad")) {
      version = mobileDetect.versionStr("iPad");
    } else if (mobileDetect.is("iPhone")) {
      version = mobileDetect.versionStr("iPhone");
    }
    const majorVersion = version ? version.split("_")[0] : "";
    setShowVersion(["14", "15", "16"].includes(majorVersion));
  }, []);

  return (
    <div>
      <Popup
        visible={showVersion}
        mask={false}
        disableBodyScroll={false}
        position="top"
        bodyStyle={{
          backgroundColor: "transparent",
        }}
      >
        <div
          style={{
            background:
              "linear-gradient(to bottom, rgba(0,0,0,0.15), transparent)",
            height: "calc(env(safe-area-inset-top) + 0px)",
          }}
        ></div>
      </Popup>
    </div>
  );
}
